module.exports = __webpack_public_path__ + "media/images/fltdental-logo@2x-355e8a8ac35b02cd45f2b464089eab57.png";